import 'svelte/internal/disclose-version';

Search[$.FILENAME] = 'src/pages/Search.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import RestaurantCard from "../components/RestaurantCard.svelte";
import MapView from "../components/MapView.svelte";
import FilterPane from "../components/FilterPane.svelte";
import Skeleton from "../components/Skeleton.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { route, replaceQuery } from "../lib/router.svelte.js";
import { buildSearchParams, selectedFilters } from "../lib/search.js";
import { takeFilterRequest } from "../lib/filterEditor.svelte.js";
import { prefs, setPrefs } from "../lib/prefs.svelte.js";
import { searchUrl } from "../lib/routes.js";

var root = $.add_locations($.from_html(`<b class="svelte-1rt8xfu"> </b>`), Search[$.FILENAME], [[156, 45]]);
var root_1 = $.add_locations($.from_html(`<b class="svelte-1rt8xfu"> </b>`), Search[$.FILENAME], [[157, 46]]);
var root_2 = $.add_locations($.from_html(`<span class="read svelte-1rt8xfu">understood as <!> <!></span>`), Search[$.FILENAME], [[154, 8]]);
var root_3 = $.add_locations($.from_html(`<div class="view-tabs svelte-1rt8xfu" role="tablist" aria-label="Results view"><button type="button" role="tab">List</button> <button type="button" role="tab">Map</button></div>`), Search[$.FILENAME], [[165, 6, [[166, 8], [167, 8]]]]);
var root_4 = $.add_locations($.from_html(`<button type="button" class="clear svelte-1rt8xfu">Clear all</button>`), Search[$.FILENAME], [[193, 6]]);
var root_5 = $.add_locations($.from_html(`<p class="map-page-note svelte-1rt8xfu"> </p>`), Search[$.FILENAME], [[216, 8]]);
var root_6 = $.add_locations($.from_html(`<!> <!>`, 1), Search[$.FILENAME], []);
var root_7 = $.add_locations($.from_html(`<nav class="pager svelte-1rt8xfu" aria-label="Pagination"><a>← Previous</a> <span> </span> <a>Next →</a></nav>`), Search[$.FILENAME], [[226, 8, [[227, 10], [228, 10], [229, 10]]]]);
var root_8 = $.add_locations($.from_html(`<div></div> <!>`, 1), Search[$.FILENAME], [[219, 6]]);

var root_9 = $.add_locations($.from_html(`<div class="head svelte-1rt8xfu"><div><h1 class="svelte-1rt8xfu"> </h1> <p class="count svelte-1rt8xfu"><!> <!></p></div> <div class="head-controls svelte-1rt8xfu"><!> <div class="sorts svelte-1rt8xfu"><label class="sr-only" for="sort">Sort results</label> <select id="sort" class="svelte-1rt8xfu"><option>Highest rated</option><option>Most reviewed</option><option>Name A–Z</option><option>Newest</option><option>Price: low to high</option><option>Price: high to low</option></select></div></div></div> <div class="layout svelte-1rt8xfu"><div class="filter-toolbar svelte-1rt8xfu"><button type="button" class="toggle svelte-1rt8xfu"> </button> <!></div> <!> <div class="results"><!></div></div>`, 1), Search[$.FILENAME], [
	[
		148,
		0,
		[
			[149, 2, [[150, 4], [151, 4]]],
			[
				163,
				2,
				[
					[
						171,
						4,
						[
							[172, 6],
							[
								173,
								6,
								[[174, 8], [175, 8], [176, 8], [177, 8], [178, 8], [179, 8]]
							]
						]
					]
				]
			]
		]
	],
	[185, 0, [[188, 2, [[189, 4]]], [201, 2]]]
]);

const $$css = {
	hash: 'svelte-1rt8xfu',
	code: '\n  .head.svelte-1rt8xfu {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 32px 0 22px;\n    flex-wrap: wrap;\n  }\n  h1.svelte-1rt8xfu { font-size: clamp(1.5rem, 3.4vw, 2rem); }\n  .count.svelte-1rt8xfu { margin: 6px 0 0; color: var(--ink-soft); font-size: 0.92rem; }\n  .read.svelte-1rt8xfu { margin-left: 8px; color: var(--ink-faint); }\n  .read.svelte-1rt8xfu b:where(.svelte-1rt8xfu) { color: var(--sage); font-weight: 600; }\n\n  .head-controls.svelte-1rt8xfu { display: flex; align-items: center; gap: 12px; }\n\n  .view-tabs.svelte-1rt8xfu {\n    display: flex;\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 3px;\n    gap: 2px;\n  }\n  .view-tabs.svelte-1rt8xfu button:where(.svelte-1rt8xfu) {\n    border: none;\n    background: none;\n    padding: 6px 14px;\n    border-radius: var(--radius-pill);\n    font-size: 0.86rem;\n    font-weight: 600;\n    color: var(--ink-soft);\n    cursor: pointer;\n  }\n  .view-tabs.svelte-1rt8xfu button.on:where(.svelte-1rt8xfu) { background: var(--accent); color: #fff; }\n\n  .sorts.svelte-1rt8xfu select:where(.svelte-1rt8xfu) {\n    background: var(--card);\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 9px 14px;\n    font-size: 0.88rem;\n    cursor: pointer;\n  }\n\n  .map-page-note.svelte-1rt8xfu { margin: 14px 0 0; color: var(--ink-faint); font-size: 0.85rem; text-align: center; }\n\n  .layout.svelte-1rt8xfu { display: block; }\n\n  /* The selections render in the search box; this is only the handle for the lists that edit them. */\n  .filter-toolbar.svelte-1rt8xfu { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }\n  .filter-toolbar.svelte-1rt8xfu .clear:where(.svelte-1rt8xfu) { margin-left: auto; }\n  .toggle.svelte-1rt8xfu {\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    background: var(--card);\n    color: var(--ink-soft);\n    font-size: 0.82rem;\n    font-weight: 600;\n    padding: 6px 14px;\n    cursor: pointer;\n  }\n  .toggle.svelte-1rt8xfu:hover { border-color: var(--accent); color: var(--accent); }\n\n  .clear.svelte-1rt8xfu {\n    border: none;\n    background: none;\n    color: var(--accent);\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 4px;\n    align-self: flex-end;\n  }\n\n  .grid.svelte-1rt8xfu {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));\n    gap: 20px;\n    transition: opacity 0.15s ease;\n  }\n  .grid.loading.svelte-1rt8xfu { opacity: 0.55; }\n\n  .pager.svelte-1rt8xfu {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    margin: 36px 0 8px;\n    font-size: 0.9rem;\n    color: var(--ink-soft);\n  }\n  .step.svelte-1rt8xfu {\n    padding: 9px 16px;\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    background: var(--card);\n    font-weight: 600;\n  }\n  .step.svelte-1rt8xfu:hover { border-color: var(--accent); color: var(--accent); }\n  .step.disabled.svelte-1rt8xfu { opacity: 0.4; pointer-events: none; }\n\n  @media (max-width: 640px) {\n    /* (unused) .filter-bar { gap: 14px; }*/\n    /* (unused) .options { max-height: 150px; }*/\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Search($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Search);
	$.append_styles($$anchor, $$css);

	let result = $.tag($.state(null), 'result');
	let facets = $.tag($.state($.proxy({ cuisines: [], cities: [] })), 'facets');
	let loading = $.tag($.state(true), 'loading');
	let error = $.tag($.state(""), 'error');
	let mapsKey = $.tag($.state(null), 'mapsKey');

	// Closed until the reader reaches for the search box — or a chip, or the Filters button — so the
	// pane never pushes the results down on its own.
	let panelOpen = $.tag($.state(false), 'panelOpen');

	let highlight = $.tag($.state(null), 'highlight');
	const view = $.tag($.derived(() => $.strict_equals(route.query.get("view"), "map") ? "map" : "list"), 'view');

	function setView(next) {
		replaceQuery({ view: $.strict_equals(next, "list") ? "" : next });
	}

	$.user_effect(() => {
		api.config().then((c) => $.set(mapsKey, c?.googleMapsBrowserKey ?? null, true)).catch(() => {});
	});

	const query = $.tag($.derived(() => route.query.get("q") ?? ""), 'query');
	const sort = $.tag($.derived(() => route.query.get("sort") ?? prefs.sort ?? "rating"), 'sort');
	const page = $.tag($.derived(() => Number(route.query.get("page") ?? "1")), 'page');

	// Each filter is a set of alternatives — the ticked boxes — OR-ed together. Cuisine and town are
	// exact matches; price and rating are ceilings, so OR-ing several means the loosest one, which is
	// what the API takes (hence the max/min reduction below). Read through the same helper the search
	// box's chips use, so the boxes and the summary cannot disagree about what is selected.
	const selection = $.tag($.derived(() => selectedFilters(route.query)), 'selection');

	const cuisines = $.tag($.derived(() => $.get(selection).cuisine), 'cuisines');
	const cities = $.tag($.derived(() => $.get(selection).city), 'cities');
	const priceBoxes = $.tag($.derived(() => $.get(selection).price), 'priceBoxes');
	const ratingBoxes = $.tag($.derived(() => $.get(selection).rating), 'ratingBoxes');

	const maxPrice = $.tag(
		$.derived(() => $.get(priceBoxes).length
			? String(Math.max(...$.get(priceBoxes).map(Number)))
			: ""),
		'maxPrice'
	);

	const minRating = $.tag(
		$.derived(() => $.get(ratingBoxes).length
			? String(Math.min(...$.get(ratingBoxes).map(Number)))
			: ""),
		'minRating'
	);

	const terms = $.tag($.derived(() => $.get(result)?.interpretation?.terms ?? []), 'terms');
	const items = $.tag($.derived(() => $.get(result)?.results?.items ?? []), 'items');
	const total = $.tag($.derived(() => $.get(result)?.results?.total ?? 0), 'total');
	const pageSize = $.tag($.derived(() => $.get(result)?.results?.pageSize ?? 24), 'pageSize');
	const pageCount = $.tag($.derived(() => Math.max(1, Math.ceil($.get(total) / $.get(pageSize)))), 'pageCount');

	$.user_effect(() => {
		api.facets().then((f) => $.set(facets, f, true)).catch(() => {});
	});

	$.user_effect(() => {
		const params = buildSearchParams({
			q: $.get(query),
			page: $.get(page),
			sort: $.get(sort),
			cuisines: $.get(cuisines),
			cities: $.get(cities),
			minRating: $.get(minRating),
			maxPrice: $.get(maxPrice)
		});

		let cancelled = false;

		$.set(loading, true);
		$.set(error, "");

		api.search(params).then((response) => {
			if (!cancelled) $.set(result, response, true);
		}).catch((e) => {
			if (!cancelled) $.set(error, e.message ?? "Search failed.", true);
		}).finally(() => {
			if (!cancelled) $.set(loading, false);
		});

		return () => {
			cancelled = true;
		};
	});

	function applyFilter(patch) {
		if (patch.sort) setPrefs({ sort: patch.sort });

		replaceQuery({ ...patch, page: 1 });
	}

	/**
	 * The pane reports a whole facet's new selection, which goes straight into the query string.
	 *
	 * A legacy link's `maxPrice`/`minRating` is only ever a fallback for *reading* it, so it is
	 * dropped whenever its facet is touched — otherwise it survives the interaction and the group
	 * springs back to its old value.
	 */
	function applyFilterPatch(patch) {
		const next = { ...patch };

		if ("price" in patch) next.maxPrice = "";
		if ("rating" in patch) next.minRating = "";

		applyFilter(next);
	}

	function clearFilters() {
		replaceQuery({
			cuisine: [],
			city: [],
			price: [],
			rating: [],
			minRating: "",
			maxPrice: "",
			page: 1
		});
	}

	// The chips themselves render in the search box (SearchBar); this page only needs to know
	// whether anything is selected, to decide whether to offer Clear.
	const hasFilters = $.tag($.derived(() => $.get(cuisines).length + $.get(cities).length + $.get(priceBoxes).length + $.get(ratingBoxes).length > 0), 'hasFilters');

	// Requests from the search box: focusing it (or clicking a chip) shows the pane, running a search
	// hides it again. Each request is consumed once, so remounting this page does not replay one.
	$.user_effect(() => {
		const request = takeFilterRequest();

		if (!request) return;

		if ($.strict_equals(request.action, "close")) {
			$.set(panelOpen, false);
			$.set(highlight, null);

			return;
		}

		$.set(panelOpen, true);

		if (request.key) {
			focusGroup(request.key);

			return;
		}

		// The search box lives in a sticky header, so a reader can reach for it from far down the
		// results. A pane that opens above the viewport is indistinguishable from one that never
		// opened, so it is brought into view — `nearest` leaves it alone when it is already visible.
		requestAnimationFrame(() => {
			document.querySelector(".filter-bar")?.scrollIntoView({ block: "nearest", behavior: "smooth" });
		});
	});

	function focusGroup(key) {
		$.set(panelOpen, true);

		// Flash the list as well as scrolling to it: a scroll is invisible when it is already on screen,
		// which makes the chip look like it did nothing.
		$.set(highlight, key, true);

		setTimeout(
			() => {
				if ($.strict_equals($.get(highlight), key)) $.set(highlight, null);
			},
			1200
		);

		// The panel has to render before its group can be scrolled to.
		requestAnimationFrame(() => {
			document.querySelector(`.group[data-key="${key}"]`)?.scrollIntoView({ block: "nearest", behavior: "smooth" });
		});
	}

	var $$exports = { ...$.legacy_api() };
	var fragment = root_9();
	var div = $.first_child(fragment);
	var div_1 = $.child(div);
	var h1 = $.child(div_1);
	var text = $.child(h1, true);

	$.reset(h1);

	var p = $.sibling(h1, 2);
	var node = $.child(p);

	{
		var consequent = ($$anchor) => {
			var text_1 = $.text('Looking…');

			$.append($$anchor, text_1);
		};

		var alternate = ($$anchor) => {
			var text_2 = $.text();

			$.template_effect(() => $.set_text(text_2, `${$.get(total) ?? ''} ${$.strict_equals($.get(total), 1) ? "place" : "places"}`));
			$.append($$anchor, text_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(loading) && !$.get(result)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Search,
			152,
			6
		);
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_3 = ($$anchor) => {
			var span = root_2();
			var node_2 = $.sibling($.child(span));

			{
				var consequent_1 = ($$anchor) => {
					var b = root();
					var text_3 = $.child(b, true);

					$.reset(b);
					$.template_effect(() => $.set_text(text_3, $.get(result).interpretation.cuisine));
					$.append($$anchor, b);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(result).interpretation.cuisine) $$render(consequent_1);
					}),
					'if',
					Search,
					156,
					10
				);
			}

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_2 = ($$anchor) => {
					var b_1 = root_1();
					var text_4 = $.child(b_1);

					$.reset(b_1);
					$.template_effect(() => $.set_text(text_4, `in ${$.get(result).interpretation.location ?? ''}`));
					$.append($$anchor, b_1);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(result).interpretation.location) $$render(consequent_2);
					}),
					'if',
					Search,
					157,
					10
				);
			}

			$.reset(span);
			$.append($$anchor, span);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.get(result)?.interpretation?.cuisine || $.get(result)?.interpretation?.location) $$render(consequent_3);
			}),
			'if',
			Search,
			153,
			6
		);
	}

	$.reset(p);
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_4 = $.child(div_2);

	{
		var consequent_4 = ($$anchor) => {
			var div_3 = root_3();
			var button = $.child(div_3);
			let classes;
			var button_1 = $.sibling(button, 2);
			let classes_1;

			$.reset(div_3);

			$.template_effect(() => {
				$.set_attribute(button, 'aria-selected', $.strict_equals($.get(view), "list"));
				classes = $.set_class(button, 1, 'svelte-1rt8xfu', null, classes, { on: $.strict_equals($.get(view), "list") });
				$.set_attribute(button_1, 'aria-selected', $.strict_equals($.get(view), "map"));
				classes_1 = $.set_class(button_1, 1, 'svelte-1rt8xfu', null, classes_1, { on: $.strict_equals($.get(view), "map") });
			});

			$.delegated('click', button, function click() {
				return setView("list");
			});

			$.delegated('click', button_1, function click_1() {
				return setView("map");
			});

			$.append($$anchor, div_3);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if ($.get(mapsKey)) $$render(consequent_4);
			}),
			'if',
			Search,
			164,
			4
		);
	}

	var div_4 = $.sibling(node_4, 2);
	var select = $.sibling($.child(div_4), 2);
	var option = $.child(select);

	option.value = option.__value = 'rating';

	var option_1 = $.sibling(option);

	option_1.value = option_1.__value = 'reviews';

	var option_2 = $.sibling(option_1);

	option_2.value = option_2.__value = 'name';

	var option_3 = $.sibling(option_2);

	option_3.value = option_3.__value = 'newest';

	var option_4 = $.sibling(option_3);

	option_4.value = option_4.__value = 'price_low';

	var option_5 = $.sibling(option_4);

	option_5.value = option_5.__value = 'price_high';
	$.reset(select);

	var select_value;

	$.init_select(select);
	$.reset(div_4);
	$.reset(div_2);
	$.reset(div);

	var div_5 = $.sibling(div, 2);
	var div_6 = $.child(div_5);
	var button_2 = $.child(div_6);
	var text_5 = $.child(button_2, true);

	$.reset(button_2);

	var node_5 = $.sibling(button_2, 2);

	{
		var consequent_5 = ($$anchor) => {
			var button_3 = root_4();

			$.delegated('click', button_3, clearFilters);
			$.append($$anchor, button_3);
		};

		$.add_svelte_meta(
			() => $.if(node_5, ($$render) => {
				if ($.get(hasFilters)) $$render(consequent_5);
			}),
			'if',
			Search,
			192,
			4
		);
	}

	$.reset(div_6);

	var node_6 = $.sibling(div_6, 2);

	{
		var consequent_6 = ($$anchor) => {
			$.add_svelte_meta(
				() => FilterPane($$anchor, {
					get facets() {
						return $.get(facets);
					},

					get selection() {
						return $.get(selection);
					},

					get highlight() {
						return $.get(highlight);
					},
					onchange: applyFilterPatch
				}),
				'component',
				Search,
				198,
				4,
				{ componentTag: 'FilterPane' }
			);
		};

		$.add_svelte_meta(
			() => $.if(node_6, ($$render) => {
				if ($.get(panelOpen)) $$render(consequent_6);
			}),
			'if',
			Search,
			197,
			2
		);
	}

	var div_7 = $.sibling(node_6, 2);
	var node_7 = $.child(div_7);

	{
		var consequent_7 = ($$anchor) => {
			$.add_svelte_meta(
				() => EmptyState($$anchor, {
					icon: '🥲',
					title: 'That didn\'t work',
					get message() {
						return $.get(error);
					}
				}),
				'component',
				Search,
				203,
				6,
				{ componentTag: 'EmptyState' }
			);
		};

		var consequent_8 = ($$anchor) => {
			$.add_svelte_meta(() => Skeleton($$anchor, { count: 9 }), 'component', Search, 205, 6, { componentTag: 'Skeleton' });
		};

		var consequent_9 = ($$anchor) => {
			$.add_svelte_meta(
				() => EmptyState($$anchor, {
					icon: '🔍',
					title: 'Nothing matched that',
					get message() {
						return `Try a broader search — a cuisine, a town, or part of a name. “${$.get(query) ?? ''}” came up empty.`;
					},
					action: { href: "/", label: "Back to browsing" }
				}),
				'component',
				Search,
				207,
				6,
				{ componentTag: 'EmptyState' }
			);
		};

		var consequent_11 = ($$anchor) => {
			var fragment_6 = root_6();
			var node_8 = $.first_child(fragment_6);

			$.add_svelte_meta(
				() => MapView(node_8, {
					get items() {
						return $.get(items);
					},

					get apiKey() {
						return $.get(mapsKey);
					}
				}),
				'component',
				Search,
				214,
				6,
				{ componentTag: 'MapView' }
			);

			var node_9 = $.sibling(node_8, 2);

			{
				var consequent_10 = ($$anchor) => {
					var p_1 = root_5();
					var text_6 = $.child(p_1);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text_6, `Showing page ${$.get(page) ?? ''} of ${$.get(pageCount) ?? ''} on the map — switch to List to page through the rest.`));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_9, ($$render) => {
						if ($.get(pageCount) > 1) $$render(consequent_10);
					}),
					'if',
					Search,
					215,
					6
				);
			}

			$.append($$anchor, fragment_6);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_7 = root_8();
			var div_8 = $.first_child(fragment_7);
			let classes_2;

			$.add_svelte_meta(
				() => $.each(div_8, 21, () => $.get(items), (restaurant) => restaurant.id, ($$anchor, restaurant) => {
					$.add_svelte_meta(
						() => RestaurantCard($$anchor, {
							get restaurant() {
								return $.get(restaurant);
							},

							get terms() {
								return $.get(terms);
							}
						}),
						'component',
						Search,
						221,
						10,
						{ componentTag: 'RestaurantCard' }
					);
				}),
				'each',
				Search,
				220,
				8
			);

			$.reset(div_8);

			var node_10 = $.sibling(div_8, 2);

			{
				var consequent_12 = ($$anchor) => {
					var nav = root_7();
					var a = $.child(nav);
					let classes_3;
					var span_1 = $.sibling(a, 2);
					var text_7 = $.child(span_1);

					$.reset(span_1);

					var a_1 = $.sibling(span_1, 2);
					let classes_4;

					$.reset(nav);

					$.template_effect(
						($0, $1) => {
							classes_3 = $.set_class(a, 1, 'step svelte-1rt8xfu', null, classes_3, { disabled: $.get(page) <= 1 });
							$.set_attribute(a, 'href', $0);
							$.set_text(text_7, `Page ${$.get(page) ?? ''} of ${$.get(pageCount) ?? ''}`);
							classes_4 = $.set_class(a_1, 1, 'step svelte-1rt8xfu', null, classes_4, { disabled: $.get(page) >= $.get(pageCount) });
							$.set_attribute(a_1, 'href', $1);
						},
						[
							() => searchUrl($.get(query), {
								page: $.get(page) - 1,
								sort: $.get(sort),
								cuisine: $.get(cuisines),
								city: $.get(cities),
								price: $.get(priceBoxes),
								rating: $.get(ratingBoxes)
							}),

							() => searchUrl($.get(query), {
								page: $.get(page) + 1,
								sort: $.get(sort),
								cuisine: $.get(cuisines),
								city: $.get(cities),
								price: $.get(priceBoxes),
								rating: $.get(ratingBoxes)
							})
						]
					);

					$.append($$anchor, nav);
				};

				$.add_svelte_meta(
					() => $.if(node_10, ($$render) => {
						if ($.get(pageCount) > 1) $$render(consequent_12);
					}),
					'if',
					Search,
					225,
					6
				);
			}

			$.template_effect(() => classes_2 = $.set_class(div_8, 1, 'grid svelte-1rt8xfu', null, classes_2, { loading: $.get(loading) }));
			$.append($$anchor, fragment_7);
		};

		$.add_svelte_meta(
			() => $.if(node_7, ($$render) => {
				if ($.get(error)) $$render(consequent_7); else if ($.get(loading) && !$.get(result)) $$render(consequent_8, 1); else if ($.strict_equals($.get(items).length, 0)) $$render(consequent_9, 2); else if ($.strict_equals($.get(view), "map")) $$render(consequent_11, 3); else $$render(alternate_1, -1);
			}),
			'if',
			Search,
			202,
			4
		);
	}

	$.reset(div_7);
	$.reset(div_5);

	$.template_effect(() => {
		$.set_text(text, $.get(result)?.interpretation?.explanation || ($.get(query) ? `Results for “${$.get(query)}”` : "Every restaurant"));

		if (select_value !== (select_value = $.get(sort))) {
			(
				select.value = (select.__value = $.get(sort)) ?? '',
				$.select_option(select, $.get(sort))
			);
		}

		$.set_attribute(button_2, 'aria-expanded', $.get(panelOpen));
		$.set_text(text_5, $.get(panelOpen) ? "Hide filters" : "Filters");
	});

	$.delegated('change', select, function change(e) {
		return applyFilter({ sort: e.currentTarget.value });
	});

	$.delegated('click', button_2, function click_2() {
		return $.set(panelOpen, !$.get(panelOpen));
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click', 'change']);